(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bmg-credit-scene"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-credit-scene]').forEach(root => {
      if (root.dataset.creditReady) return;
      const range = root.querySelector('[data-credit-range]');
      const purchase = root.querySelector('[data-credit-purchase]');
      const credit = root.querySelector('[data-credit-earned]');
      if (!range || !purchase || !credit) return;
      root.dataset.creditReady = 'true';
      const money = value => '$' + value.toLocaleString('en-AU', {
        minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
        maximumFractionDigits: 2
      });
      const update = () => {
        const amount = Number(range.value);
        const earned = Math.round(amount * 10) / 100;
        const progress = 100 * (amount - Number(range.min)) / (Number(range.max) - Number(range.min));
        range.style.setProperty('--credit-progress', `${progress}%`);
        purchase.textContent = money(amount);
        credit.textContent = money(earned);
        range.setAttribute('aria-valuetext', root.dataset.valueTemplate.replace('__PURCHASE__', money(amount)).replace('__CREDIT__', money(earned)));
      };
      range.addEventListener('input', update);
      range.addEventListener('change', update);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
